/****************************************************
 * Module Name:  addDepartmentGroup.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import Constants from "../../utility/constants";
import Select from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField, Tooltip } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import DepartmentGroupProxy from "../../utility/proxy/manager/manufacturingProxy/departmentGroupProxy";
import { LoadingButton } from "@mui/lab";
import UserProxy from "../../utility/proxy/manager/userProxy";
import logo from '../../images/pansuriya.jpg'
import SaveIcon from '@mui/icons-material/Save';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import UserDetailModal from "../operations/userDetailModal";

const setPropSourceDataofDepartmentGroupHead = (dataToMap) => {
  let newArr = [];
  dataToMap.map((item) => {
    let option = {
      value: item.departmentgroupheaduserid,
      label: item.departmentgroupheadusername,
    };
    newArr.push(option);
    return true;
  });
  return newArr;
};

export default class AddDepartmentGroup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newdepartmentGroup: this.props.editOperation
        ? this.props.sourceData.departmentgroupname
        : "",
      newdescription: this.props.editOperation
        ? this.props.sourceData.departmentgroupdesc
        : "",
      newmaxdayspacketallowed: this.props.editOperation
        ? this.props.sourceData.maxdayspacketallowed
        : "3",

      newDepartmentGroupHead: this.props.editOperation
        ? setPropSourceDataofDepartmentGroupHead(
          this.props.sourceData.departmentgroupheads
        )
        : "",
      showDepartmentUsersLoadSpinner: true,
      showError: false,
      userOptions: [],
      showUserLoadSpinner: true,
      validateDepartmentGroupPresentSpinner: false,
      showValidationMessage: false,
      departmentGroupAvailable: true,

      departmentGroupValidationError: "",
      showUserDetailModal: false,
    };
    this.getAllUser(false);
  }

  getAllUser = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showUserLoadSpinner: true, showDepartmentUsersLoadSpinner: true });
    UserProxy.UsersThatAreNotDeptGroupHeads((response) => {
      this.setAllUserData(response)
      this.setState({
        showDepartmentUsersLoadSpinner: false
      })
    }
    );
  };

  setAllUserData = (response) => {
    let optionsArray = [];

    // this is added because if user removes the existing head then it cant select it again as we fetch only those users that are not head from the api
    if (Object.keys(this.props.sourceData).length > 0) {
      this.props.sourceData.departmentgroupheads.map((data) => {
        let option = {
          value: data.departmentgroupheaduserid,
          label: data.departmentgroupheaduserid + " | " + data.departmentgroupheadusername,
        };
        optionsArray.push(option);
        return true;
      });
    }

    response.map((data) => {
      let option = {
        value: data.id,
        label: data.id + " | " + data.username,
      };
      optionsArray.push(option);

      return true;
    });
    this.setState({
      userOptions: optionsArray,
      newDepartmentGroupHead:
        this.state.newDepartmentGroupHead === "" && optionsArray.length > 0
          ? optionsArray[0]
          : this.state.newDepartmentGroupHead,
      showUserLoadSpinner: false,
      showDepartmentUsersLoadSpinner: false,
    });
  };

  getDepartmentGroupById = () => {
    DepartmentGroupProxy.GetSingleDepartmentGroup(
      this.props.departmentGroupId,
      (response) =>
        this.setState({
          newdepartmentGroup:
            response !== null &&
              response !== undefined &&
              response.name !== null
              ? response.name
              : "",
          newdescription:
            response !== null &&
              response !== undefined &&
              response.description !== null
              ? response.description
              : "",
        })
    );
  };

  handleSave = () => {
    let headids = Array.isArray(this.state.newDepartmentGroupHead)
      ? this.state.newDepartmentGroupHead.map(i => i.value)
      : [this.state.newDepartmentGroupHead.value];

    let data = {
      id:
        this.props.sourceData === undefined
          ? this.props.departmentGroupId
          : this.props.editOperation
            ? this.props.sourceData.departmentgroupid
            : undefined,
      name: this.state.newdepartmentGroup,
      description: this.state.newdescription,
      maxdayspacketallowed: this.state.newmaxdayspacketallowed,
      headids: headids
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data))
          this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateDepartmentGroupPresent = (departmentGroupEntered) => {
    if (!departmentGroupEntered || departmentGroupEntered.trim() === "") return;

    this.setState({
      validateDepartmentGroupPresentSpinner: true,
    });

    DepartmentGroupProxy.CheckDepartmentGroupAvailable(
      departmentGroupEntered,
      (response) => {
        //if we got response that means departmentGroup is present at backend
        if (response) {
          //DepartmentGroupName already present
          this.setState({
            validateDepartmentGroupPresentSpinner: false,
            showValidationMessage: true,
            departmentGroupAvailable: false,
          });
        } else {
          //DepartmentGroupName not available, so can be used
          this.setState({
            validateDepartmentGroupPresentSpinner: false,
            showValidationMessage: true,
            departmentGroupAvailable: true,
          });
        }
      }
    );
  };

  buttonDisable = () => {
    if (this.props.sourceData === undefined) {
      return false;
    } else if (!this.props.editOperation) {
      return (
        !this.state.showValidationMessage ||
        !this.state.departmentGroupAvailable ||
        !this.state.newmaxdayspacketallowed ||
        this.state.newDepartmentGroupHead.length === 0
      );
    } else if (this.props.editOperation) {
      return this.state.newDepartmentGroupHead.length === 0 || this.state.newmaxdayspacketallowed === 0;
    }
    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add department Group validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        {this.state.showUserDetailModal ? (
          <UserDetailModal
            show={true}
            handleClose={() => this.setState({ showUserDetailModal: false })}
            handleSelect={(selectedOption) => {
              const selectedCustomers = this.state.userOptions.filter(opt =>
                selectedOption.includes(opt.value)
              );
              this.setState({
                newDepartmentGroupHead: selectedCustomers,
                showUserDetailModal: false
              });
            }}
            userids={this.state.userOptions.map(cust => cust.value)}
            selectedIds={
              Array.isArray(this.state.newDepartmentGroupHead)
                ? this.state.newDepartmentGroupHead.map(i => i.value)
                : [this.state.newDepartmentGroupHead.value]
            }
            usertype={"U"}
            loading={this.state.showUserDetailModal}
            isMulti={true}
          />
        ) : null}

        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false} dialogClassName="custom-modalSize">
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation || this.props.sourceData === undefined
                ? "Edit Department Group"
                : "Add New Department Group"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <table style={{ width: "100%" }}>
                <tbody>
                  {this.props.editOperation && (
                    <tr>
                      <td>
                        <Form.Label>Department Group Id</Form.Label>
                      </td>
                      <td>
                        <Form.Label>
                          {this.props.sourceData.departmentgroupid}
                        </Form.Label>
                      </td>
                    </tr>
                  )}
                  {!this.props.sourceData && (
                    <tr>
                      <td>
                        <Form.Label>Department Group Id</Form.Label>
                      </td>
                      <td>
                        <Form.Label>{this.props.departmentGroupId}</Form.Label>
                      </td>
                    </tr>
                  )}
                  {(this.props.editOperation || !this.props.sourceData) && (
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  )}
                  <tr>
                    <td style={{ width: "45%" }}>
                      <Form.Label>
                        Department Group
                        <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    {this.props.editOperation || !this.props.sourceData ? (
                      <td>
                        <Form.Label>{this.state.newdepartmentGroup}</Form.Label>
                      </td>
                    ) : (
                      <td>
                        <TextField
                          margin="normal"
                          fullWidth
                          size="small"
                          label="Department Group (required)"
                          placeholder="Enter Department Group"
                          value={this.state.newdepartmentGroup}
                          autoFocus
                          onBlur={(e) =>
                            this.validateDepartmentGroupPresent(
                              this.state.newdepartmentGroup
                            )
                          }
                          onChange={(e) =>
                            this.setState({
                              newdepartmentGroup: e.target.value,
                              showValidationMessage: false,
                              departmentGroupValidationError: Utility.CheckIsPresent(
                                e.target.value
                              )
                                ? ""
                                : "Department Group Cannot be Empty",
                            })
                          }
                          helperText={this.state.departmentGroupValidationError}
                          error={
                            this.state.departmentGroupValidationError.length > 0
                          }
                        />
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      {this.state.validateDepartmentGroupPresentSpinner ? (
                        <CircularProgress size="1rem" />
                      ) : !this.state.showValidationMessage ? (
                        <Box>&nbsp;</Box>
                      ) : this.state.departmentGroupAvailable ? (
                        <font color="green">Department Group available</font>
                      ) : (
                        <font color="red">Department Group not available</font>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>MAX DAYS PACKET ALLOWED
                        <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        type="number"
                        label="Max Days Packet Allowed"
                        placeholder="Enter Days"
                        value={this.state.newmaxdayspacketallowed}
                        onChange={(e) =>
                          this.setState({
                            newmaxdayspacketallowed: e.target.value,
                          })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Description</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Description"
                        placeholder="Enter Description"
                        value={this.state.newdescription}
                        onChange={(e) =>
                          this.setState({
                            newdescription: e.target.value,
                          })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Dept Group Head
                        <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <Select menuPlacement="auto"
                        blurInputOnSelect={false}
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                        value={this.state.newDepartmentGroupHead}
                        isSearchable={true}
                        isMulti
                        closeMenuOnSelect={true}
                        name="Department Group Head"
                        menuPortalTarget={document.body}
                        styles={Constants.Styles}
                        options={this.state.userOptions}
                        onChange={(selectedOption) =>
                          this.setState({
                            newDepartmentGroupHead: selectedOption,
                          })
                        }
                      />
                    </td>
                    <td>
                      <Tooltip title="View More Data">
                        <OpenInNewIcon
                          style={{ fontSize: "20px", cursor: "pointer", marginLeft: "5px" }}
                          color="action"
                          onClick={() => {
                            this.setState({
                              showUserDetailModal: true,
                            });
                          }}
                        />
                      </Tooltip>
                    </td>
                    <td>
                      {this.state.showDepartmentUsersLoadSpinner ? (
                        <CircularProgress
                          size="1em"
                          sx={{ mt: 0, ml: 0.7 }}
                        />
                      ) : (
                        <Tooltip title="Reload">
                          <RefreshOutlinedIcon
                            color="primary"
                            fontSize="medium"
                            onClick={() => this.getAllUser(true)}
                            sx={{
                              cursor: "pointer",
                              mt: 1,
                            }}
                          />
                        </Tooltip>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                </tbody>
              </table>
            </center>
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
